type CustomerIdType = string | number | null | undefined

export const normalizeCustomerNumber = (id: CustomerIdType): string => `${id ?? ''}`.trim()

export const isCustomerNumberValid = (userId: CustomerIdType, anonymousUserId?: string): boolean => {
  if (!userId) return false

  const normalizedValue = normalizeCustomerNumber(userId)
  let valid = normalizedValue.length > 0
  if (valid && anonymousUserId) {
    valid = valid && normalizedValue !== anonymousUserId
  }
  return valid
}

export const isCustomerNumberChanged = (source: CustomerIdType, target: CustomerIdType): boolean => {
  const normalizedSource = normalizeCustomerNumber(source)
  const normalizedTarget = normalizeCustomerNumber(target)
  return Boolean(normalizedSource && normalizedTarget) && normalizedSource !== normalizedTarget
}
